module.exports = __webpack_public_path__ + "media/images/top/original04-866c3b7ba62ce92f7fc351afdda05a64.jpg";